import styled from 'styled-components';

import { FilterInDropdown } from '@sorare/core/src/atoms/dropdowns/FilterInDropdown';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import useScreenSize from '@sorare/core/src/hooks/device/useScreenSize';
import { FilterWidget } from '@sorare/core/src/lib/filters';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const FilterRoot = styled.div`
  padding: var(--double-unit) 0;
  overflow-y: hidden;
`;

const FilterPaper = styled(Vertical)`
  max-height: 70vh;
  padding: 0 var(--double-unit);
  overflow: auto;
  @media ${tabletAndAbove} {
    min-width: calc(36 * var(--unit));
  }
`;
type Props = {
  widget: FilterWidget;
};

export const DropdownFilter = ({ widget }: Props) => {
  const { up: isLaptopOrAbove } = useScreenSize('laptop');
  return (
    <FilterInDropdown
      gap={0}
      forceMount
      buttonLabel={widget?.shortTitle || widget?.title}
    >
      <FilterRoot>
        <FilterPaper>
          {!isLaptopOrAbove && widget?.title}
          {widget.Component({ visible: true })}
        </FilterPaper>
      </FilterRoot>
    </FilterInDropdown>
  );
};
